// extracted by mini-css-extract-plugin
module.exports = {"grid":"GovInfo_grid__1Z2HN","wrapper":"GovInfo_wrapper__3AHRa","load":"GovInfo_load__3oJbr"};